import { render, staticRenderFns } from "./CommonPageBtn.vue?vue&type=template&id=8c2c7710&scoped=true"
import script from "./CommonPageBtn.vue?vue&type=script&lang=js"
export * from "./CommonPageBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2c7710",
  null
  
)

export default component.exports